import { render, staticRenderFns } from "./AddAttachmentModalForm.vue?vue&type=template&id=5ed33083"
import script from "./AddAttachmentModalForm.vue?vue&type=script&lang=js"
export * from "./AddAttachmentModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports